export default __webpack_public_path__ + "static/0264-b5111fde55f4404b22b4de112e1a08ee.png";